import React from 'react';

// hooks
import { useKeyboardClick } from 'shared/hooks/useKeyboardClick';

// icon
import CopyIcon from '@nykaa/ui-components/Icons/copy';

// styles
import { CopyCodeWrapper } from './styles';

const COPY_ICON_SIZE = '12px';

const ARIA_LABELS = {
  COPY_CODE: 'Copy code',
};

export default function CopyCode({
  copyCode,
  handleCopyClick,
}: {
  copyCode: string;
  handleCopyClick: (e: React.MouseEvent) => void;
}) {
  const keyboardProps = useKeyboardClick(handleCopyClick);

  return (
    <CopyCodeWrapper>
      <div
        className="copycode-container"
        {...keyboardProps}
        aria-label={ARIA_LABELS.COPY_CODE}
      >
        {copyCode}
        <CopyIcon size={COPY_ICON_SIZE} />
      </div>
    </CopyCodeWrapper>
  );
}
